import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';
import { toLocalFormattedString, toUTCFormattedString } from '../../utils/dateTransform';

const DateCell: React.FC<DateCellProps> = (props) => {
	const { value, showInvalid, showTimezone = true, showTimeOnly = false } = props;
	const formattedValue = toLocalFormattedString(value as string, showInvalid, showTimezone, showTimeOnly);
	const formattedTitle = toUTCFormattedString(value as string, showInvalid, true, showTimeOnly);

	return (
		<Tooltip title={formattedTitle} placement='bottom-start'>
			<Typography variant='inherit' display='inline'>
				{formattedValue}
			</Typography>
		</Tooltip>
	);
};

type DateCellProps = {
	value: string | null | undefined;
	showInvalid?: boolean | string;
	showTimezone?: boolean;
	showTimeOnly?: boolean;
};

export default DateCell;
